
import  './Footer.css'

export function Footer() {

    return (
        <div className="container-footer">
            <div className="footer">
                <p>Hecho por @Victor Pinto</p>
            </div>
        </div>
    )
}
